export default __webpack_public_path__ + "static/media/G0860.Breech_02_SemiR.1695377580000.64e8b41c.jpg";